<template>
  <date-picker-erp
    :value="_value"
    placeholder="选择日期时间"
    v-bind="props"
    @change="onChange"
  ></date-picker-erp>
</template>

<script>
import storeMixins from '../store-mixins';

export default {
  mixins: [storeMixins],
  props: ['props', 'tipRule', 'value'],
  computed: {
    key() {
      return this.props.name;
    },
    tips() {
      return this.tipRule || [];
    },
    hasTips() {
      return this.tips.length;
    },
    _value() {
      return {start: this.tbForm[this.key]};
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {};
      newFormFields[this.key] = v.start;
      this.updateTbForm(newFormFields);
    },
  },
};
</script>

<style></style>